import { render, staticRenderFns } from "./cModalServicios.vue?vue&type=template&id=1c9e1242"
import script from "./cModalServicios.vue?vue&type=script&lang=js"
export * from "./cModalServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports